import React, { useEffect, useState } from 'react';
import { Form, Tabs, Row, Modal, InputNumber, Card } from 'antd';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormItem from 'antd/lib/form/FormItem';
import { useForm } from 'antd/lib/form/Form';
import AssetServiceUseList from '../AssetServiceUseList';
import { ParAssetCatalogServiceResponse } from 'services/assetconfig';
import InputRate from 'components/InputRate';
import InputCurrency from 'components/InputCurrency';

const { TabPane } = Tabs;

type ModalAssetServiceDetailProps = {
  record?: ParAssetCatalogServiceResponse;
  //   refetch: () => void;
  onCancel?: () => void;
  visible: boolean;
};



const ModalAssetServiceDetail = ({
  record,
  onCancel,
  visible,
}: ModalAssetServiceDetailProps) => {
  const [form] = useForm();
  const [activeKey, setActiveKey] = useState('1');
  useEffect(()=>{
    if(record){
        form.setFieldsValue({
            servuseunit:record.servuseunit,
            servusefrequency:record.servusefrequency,
            servuseqty:record.servuseqty,
            servuseminamount:record.servuseminamount,
            servusemaxamount:record.servusemaxamount,
            servusecoverage:record.servusecoverage,
            servusedeductionamount:record.servusedeductionamount,
            servusedeductionpercenrage:record.servusedeductionpercenrage
        })
    }
})
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      width={1600}
      destroyOnClose
      onOk={onCancel}
      footer={null}
      title={<GetLabel label="Service Use List" />}
    >
      <DF.Provider pagcode="servicelist">
        <Form form={form} layout="vertical">
          <FormItem shouldUpdate noStyle>
              <Tabs
                onChange={(activeKey) => setActiveKey(activeKey)}
                type="card"
              >
                <TabPane key="1" tab="AssetServiceDetail">
                  <Card>
                    <Row gutter={16}>
                      <FormInput col xs={8} name="servuseunit">
                        <ParListSelect parcode="SUSEUNIT" />
                      </FormInput>

                      <FormInput col xs={8} name="servusefrequency">
                        <ParListSelect parcode="SUSEFREQ" />
                      </FormInput>
                      <FormInput col xs={8} name="servuseqty">
                        <InputNumber />
                      </FormInput>
                    </Row>
                    <Row gutter={16}>
                      <Form.Item name="servuseminamount" noStyle>
                        <FormInput col xs={8} name="servuseminamount">
                          <InputCurrency
                            currcode={form?.getFieldValue('currcode')}
                            name="servuseminamount"
                          />
                        </FormInput>
                      </Form.Item>
                      <Form.Item name="servusemaxamount" noStyle>
                        <FormInput col xs={8} name="servusemaxamount">
                          <InputCurrency
                            currcode={form?.getFieldValue('currcode')}
                            name="servusemaxamount"
                          />
                        </FormInput>
                      </Form.Item>

                      <FormInput col xs={8} name="servusecoverage">
                        <InputRate />
                      </FormInput>
                    </Row>
                    <Row gutter={16}>
                      <Form.Item name="servusedeductionamount" noStyle>
                        <FormInput col xs={8} name="servusedeductionamount">
                          <InputCurrency
                            currcode={form?.getFieldValue('currcode')}
                            name="servusedeductionamount"
                          />
                        </FormInput>
                      </Form.Item>

                      <FormInput col xs={8} name="servusedeductionpercenrage">
                        <InputRate />
                      </FormInput>
                    </Row>
                  </Card>
                </TabPane>
                <TabPane tab="AssetServiceUse" key="2">
                  {record && <AssetServiceUseList record={record} />}
                </TabPane>
              </Tabs>
          </FormItem>
        </Form>
      </DF.Provider>
    </Modal>
  );
};
export default ModalAssetServiceDetail;
